import tableLight from "./table_icon_14px_light.png";
import tableDark from "./table_icon_15px_dark.png";

type TableIconProps = {
  color?: "light" | "dark";
};

const TABLE_IMAGES: Record<"light" | "dark", string> = {
  light: tableLight,
  dark: tableDark,
};

export const TableIcon = ({ color }: TableIconProps) => (
  <img src={TABLE_IMAGES[color || "light"]} alt="Table icon" />
);
